import script from "./ScoreAchievement.vue?vue&type=script&setup=true&lang=js"
export * from "./ScoreAchievement.vue?vue&type=script&setup=true&lang=js"

import "./ScoreAchievement.vue?vue&type=style&index=0&id=03cef73a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03cef73a"]])

export default __exports__